import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Scrolls to top on route change; if the URL carries a hash (e.g. from the
// retired-route redirects like /pricing -> /solutions/housing#pricing), scroll
// to that element instead once the target page has rendered.
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      // Give the destination page a frame to mount before looking up the anchor.
      const id = hash.replace(/^#/, "");
      requestAnimationFrame(() => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "instant", block: "start" });
        } else {
          window.scrollTo({ top: 0, left: 0, behavior: "instant" });
        }
      });
    } else {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    }
  }, [pathname, hash]);
  return null;
}
